"use client";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Image from "next/image";
import LogoLightMode from "../../../public/logo-next-light-mode.png";
import LogoDarkMode from "../../../public/logo-next-dark-mode.png";

export function LoadingOverlay() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) return 0;
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 90); // Stay at 90 until loaded
            });
        }, 200);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/60 dark:bg-[#05050a]/60 backdrop-blur-xl transition-all duration-500">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="relative flex flex-col items-center gap-8"
            >
                {/* Logo with glow effect */}
                <div className="relative group">
                    <div className="absolute -inset-4 bg-indigo-500/20 rounded-full blur-2xl group-hover:bg-indigo-500/30 transition-all duration-500 animate-pulse" />
                    <Image
                        src={LogoLightMode}
                        alt="Loading..."
                        className="h-10 w-auto relative z-10 dark:hidden block"
                        priority
                    />
                    <Image
                        src={LogoDarkMode}
                        alt="Loading..."
                        className="h-10 w-auto relative z-10 hidden dark:block"
                        priority
                    />
                </div>

                {/* Animated loading bar container */}
                <div className="w-48 h-1 bg-slate-200 dark:bg-white/10 rounded-full overflow-hidden relative">
                    <motion.div
                        className="absolute inset-y-0 left-0 bg-gradient-to-r from-indigo-500 via-violet-500 to-fuchsia-500"
                        initial={{ width: "0%" }}
                        animate={{ width: `${progress}%` }}
                        transition={{ duration: 0.3, ease: "linear" }}
                    />
                </div>

                {/* Subtle text */}
                <motion.p
                    initial={{ opacity: 0, y: 5 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400 dark:text-gray-500"
                >
                    Menyiapkan Pengalaman Anda
                </motion.p>
            </motion.div>

            {/* Background ambient accents */}
            <div className="absolute top-1/4 -left-20 w-96 h-96 bg-indigo-600/10 rounded-full blur-[100px] pointer-events-none" />
            <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-fuchsia-600/10 rounded-full blur-[100px] pointer-events-none" />
        </div>
    );
}
